/**
 * 주어진 값이 null이거나 undefined이 아닌지 확인합니다.
 *
 * null이거나 undefined일경우 false, 아닐경우 true를 반환합니다.
 */
export const isNotNil = <T>(x: T | null | undefined): x is T => {
  return x != null;
};
